import React, { useState } from "react";
import {
  Button,
  Flex,
  Loader,
  Radio,
  RadioGroupField,
  TextField,
  Text,
  PasswordField,
} from "@aws-amplify/ui-react";
import "./Users.css";
import { createUserAPI } from "../../data/api";
import { UserRole, getUserRoleLabel } from "../../data/interfaces";

const defaultForm = {
  username: "",
  name: "",
  email: "",
  password: "",
  ruolo: "",
};

const CreateUserForm = (props) => {
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [errorCreate, setErrorCreate] = useState(false);

  // create user form data
  const [createUserFormValues, setCreateUserFormValues] = useState(() => {
    const storage = localStorage.getItem('createUserFormValues');
    return storage ? JSON.parse(storage) : defaultForm;
  });

  const changeInputCreateUserForm = (e) => {
    const { name, value } = e.target;
    const newValue = {
      ...createUserFormValues,
      [name]: value,
    };
    setCreateUserFormValues(newValue);
    localStorage.setItem('createUserFormValues', JSON.stringify(newValue));
  };

  const resetCreateUserForm = () => {
    setCreateUserFormValues(defaultForm);
    localStorage.setItem('createUserFormValues', JSON.stringify(defaultForm));
  }

  const createUser = async () => {
    try{
      setLoadingCreate(true);
      setErrorCreate(false);
      await createUserAPI(createUserFormValues.username, createUserFormValues.email, createUserFormValues.password, createUserFormValues.name, createUserFormValues.ruolo);
      setLoadingCreate(false);
      props.onCreate();
      resetCreateUserForm();
    } catch (e) {
      console.log('Create user failed ', e);
      setErrorCreate(true);
      setLoadingCreate(false);
    }
  };

  return (
    <Flex as="form" direction="column" width="100%" onSubmit={(e) => {e.preventDefault(); createUser();}}>
      <TextField
        value={createUserFormValues.username}
        onChange={changeInputCreateUserForm}
        name="username"
        label={
          <Text>
            <b>Username</b>
          </Text>
        }
        type="text"
        isRequired={true}
      />
      <TextField
        value={createUserFormValues.name}
        onChange={changeInputCreateUserForm}
        name="name"
        label={
          <Text>
            <b>Nome e cognome</b>
          </Text>
        }
        type="text"
        isRequired={true}
        autoComplete="new-password"
      />
      <TextField
        value={createUserFormValues.email}
        onChange={changeInputCreateUserForm}
        name="email"
        label={
          <Text>
            <b>Email</b>
          </Text>
        }
        type="email"
        isRequired={true}
        autoComplete="new-password"
      />

      <PasswordField
        value={createUserFormValues.password}
        onChange={changeInputCreateUserForm}
        name="password"
        label={
          <Text>
            <b>Password temporanea</b>
          </Text>
        }
        isRequired={true}
        autoComplete="new-password"
      />
      <RadioGroupField
        legend={
          <Text>
            <b>Ruolo</b>
          </Text>
        }
        name="ruolo"
        value={createUserFormValues.ruolo}
        onChange={changeInputCreateUserForm}
        isRequired={true}
      >
        {Object.values(UserRole).map((item) => {
          return <Radio value={item}>{getUserRoleLabel(item)}</Radio>
        })}
      </RadioGroupField>
      <Button
        type="submit"
        variation="primary"
        width={{ base: "100%", large: "100%" }}
        disabled={loadingCreate}
      >
        {loadingCreate ? <Loader/> : "Crea utente"}
      </Button>
      { errorCreate ? <span style={{color: "red", marginLeft: "auto"}}>Errore nella creazione dell'utente!</span> : ""}
    </Flex>
  );
};

export default CreateUserForm;
